import { yupResolver } from '@hookform/resolvers/yup';
import { Box, FormControl } from '@mui/material';
import { styled } from '@mui/system';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';
import * as yup from 'yup';

import MeetingInfo from './MeetingInfo';
import SignUpContainer from './SignUpContainer';
import { ControlledInput } from '../../components/forms';
import { StyledLoadingButton } from '../../components/forms/LoadingButton';

const FormFields = styled(Box)`
    margin-bottom: 0.5rem;
`;

const StyledFormControl = styled(FormControl)`
    margin-bottom: 0.5rem;
`;

const FormContainer = styled(Box)`
    display: flex;
    align-items: center;
`;

const SignInButton = styled(StyledLoadingButton)`
    padding: 8px 12px;
    font-size: 16px;
`;

// this should match node_pod/lib/auth/password-guardian.ts -> passwordRegex
const passwordRegex = /(?=^.{10,}$)(?=.*\d)(?=.*[a-zA-Z])(?![.\n]).*$/;

const EmailPasswordSignUpForm = () => {
    const { signUp, isAuthenticating, meetingData, isOriginMeeting } = useContainer(SignUpContainer);

    const { t } = useTranslation('sign-up');

    const schema = yup.object({
        name: yup.string().required(t('errors.invalid-name')),
        email: yup.string().email(t('errors.invalid-email')).required(t('errors.invalid-email')),
        password: yup
            .string()
            .required(t('errors.requires-password'))
            .matches(passwordRegex, t('errors.invalid-password')),
        'confirm-password': yup
            .string()
            .required(t('errors.invalid-confirm-password-match'))
            .oneOf([yup.ref('password'), null], t('errors.invalid-confirm-password-match'))
    });

    const { control, handleSubmit } = useForm({
        resolver: yupResolver(schema),
        defaultValues: { name: '', email: '', password: '', 'confirm-password': '' }
    });

    const onSubmit = async (data: { email; password; name }) => {
        signUp(data);
    };

    return (
        <>
            {meetingData && <MeetingInfo className={meetingData.className} classTimes={meetingData.classTimes} />}
            <FormContainer>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormFields>
                        <StyledFormControl fullWidth>
                            <ControlledInput
                                type="name"
                                name="name"
                                label={t('name')}
                                control={control}
                                autoComplete="name"
                                autoFocus
                            />
                        </StyledFormControl>
                        <StyledFormControl fullWidth>
                            <ControlledInput
                                type="email"
                                name="email"
                                label={t('email')}
                                control={control}
                                autoComplete="email"
                            />
                        </StyledFormControl>
                        <StyledFormControl fullWidth>
                            <ControlledInput
                                type="password"
                                name="password"
                                label={t('password')}
                                control={control}
                                autoComplete="new-password"
                            />
                        </StyledFormControl>
                        <StyledFormControl fullWidth>
                            <ControlledInput
                                type="password"
                                name="confirm-password"
                                label={t('confirm-password')}
                                control={control}
                                autoComplete="new-password"
                            />
                        </StyledFormControl>
                    </FormFields>
                    <SignInButton fullWidth variant={'contained'} type={'submit'} loading={isAuthenticating}>
                        {isOriginMeeting ? t('sign-up-and-join-your-class') : t('sign-up')}
                    </SignInButton>
                </form>
            </FormContainer>
        </>
    );
};

export default EmailPasswordSignUpForm;
